module.exports = __webpack_public_path__ + "assets/img/advisory-icon.46822b11.png";